import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, toHandlers as _toHandlers, mergeProps as _mergeProps, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "loader-wrap"
}
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "lds-ellipsis" }, [
  /*#__PURE__*/_createVNode("div"),
  /*#__PURE__*/_createVNode("div"),
  /*#__PURE__*/_createVNode("div"),
  /*#__PURE__*/_createVNode("div")
], -1)
const _hoisted_3 = { class: "card d-block" }
const _hoisted_4 = { class: "title mb-2" }
const _hoisted_5 = { class: "breadcrumb-wrap" }
const _hoisted_6 = { "aria-label": "breadcrumb" }
const _hoisted_7 = { class: "breadcrumb mb-0" }
const _hoisted_8 = { class: "breadcrumb-item" }
const _hoisted_9 = {
  href: "#/dashboard",
  class: ""
}
const _hoisted_10 = /*#__PURE__*/_createVNode("i", { class: "fa fa-home mr-2" }, null, -1)
const _hoisted_11 = { class: "breadcrumb-item" }
const _hoisted_12 = { href: "javascript:void(0)" }
const _hoisted_13 = {
  class: "breadcrumb-item active",
  "aria-current": "page"
}
const _hoisted_14 = { class: "col-lg-12" }
const _hoisted_15 = { class: "text-lg-right" }
const _hoisted_16 = /*#__PURE__*/_createVNode("i", { class: "fa fa-arrow-left mr-2" }, null, -1)
const _hoisted_17 = { class: "card d-block" }
const _hoisted_18 = { class: "tab-wrap" }
const _hoisted_19 = {
  class: "tab-content",
  id: "myTabContent"
}
const _hoisted_20 = {
  class: "tab-pane fade show active",
  id: "member-phase",
  role: "tabpanel",
  "aria-labelledby": "member-phase-tab"
}
const _hoisted_21 = { class: "border p-3 rounded mb-3" }
const _hoisted_22 = { class: "row" }
const _hoisted_23 = { class: "col-md-6" }
const _hoisted_24 = { class: "iconed-holder d-flex mt-2" }
const _hoisted_25 = /*#__PURE__*/_createVNode("div", { class: "bordered-icon mr-3 mt-1" }, [
  /*#__PURE__*/_createVNode("i", { class: "fa fa-money-bill-wave" })
], -1)
const _hoisted_26 = { class: "desc-wrap" }
const _hoisted_27 = { class: "col-md-6" }
const _hoisted_28 = { class: "iconed-holder d-flex mt-2" }
const _hoisted_29 = /*#__PURE__*/_createVNode("div", { class: "bordered-icon mr-3 mt-1" }, [
  /*#__PURE__*/_createVNode("i", { class: "fa fa-calendar" })
], -1)
const _hoisted_30 = { class: "desc-wrap" }
const _hoisted_31 = { class: "text-green" }
const _hoisted_32 = /*#__PURE__*/_createTextVNode(" - ")
const _hoisted_33 = { class: "text-danger" }
const _hoisted_34 = { class: "row" }
const _hoisted_35 = { class: "col-md-6" }
const _hoisted_36 = { class: "border p-3 rounded mb-3" }
const _hoisted_37 = { class: "form-group mb-0" }
const _hoisted_38 = { for: "Name" }
const _hoisted_39 = { class: "col-md-6" }
const _hoisted_40 = { class: "border p-3 rounded mb-3" }
const _hoisted_41 = { class: "form-group mb-0" }
const _hoisted_42 = { for: "Desc" }
const _hoisted_43 = { class: "border p-3 rounded mb-3" }
const _hoisted_44 = { class: "row" }
const _hoisted_45 = { class: "col-md-3" }
const _hoisted_46 = { class: "form-group" }
const _hoisted_47 = { for: "Priority" }
const _hoisted_48 = { value: "3" }
const _hoisted_49 = { value: "2" }
const _hoisted_50 = { value: "1" }
const _hoisted_51 = { class: "col-md-3" }
const _hoisted_52 = { class: "form-group" }
const _hoisted_53 = { for: "Startdate" }
const _hoisted_54 = { class: "col-md-3" }
const _hoisted_55 = { class: "form-group" }
const _hoisted_56 = { for: "Startdate" }
const _hoisted_57 = { class: "col-md-3" }
const _hoisted_58 = { class: "form-group" }
const _hoisted_59 = { for: "Enddate" }
const _hoisted_60 = {
  key: 0,
  class: "col-md-6"
}
const _hoisted_61 = { class: "form-group" }
const _hoisted_62 = { for: "Startdate" }
const _hoisted_63 = {
  key: 1,
  class: "row"
}
const _hoisted_64 = { class: "shadowed-card bg-white mt-1" }
const _hoisted_65 = { class: "time-slot-block mb-2 " }
const _hoisted_66 = /*#__PURE__*/_createVNode("i", { class: "fas fa-hourglass-half" }, null, -1)
const _hoisted_67 = {
  key: 2,
  for: "Member"
}
const _hoisted_68 = { key: 3 }
const _hoisted_69 = {
  key: 4,
  class: "row"
}
const _hoisted_70 = { class: "col-md-6" }
const _hoisted_71 = { class: "form-group mb-md-0" }
const _hoisted_72 = { for: "Member" }
const _hoisted_73 = {
  key: 0,
  class: "row"
}
const _hoisted_74 = { class: "shadowed-card bg-white mt-1" }
const _hoisted_75 = /*#__PURE__*/_createVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_76 = { class: "time-slot-block mb-2" }
const _hoisted_77 = {
  key: 5,
  class: "form-group"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ErrorList = _resolveComponent("ErrorList")
  const _component_v_date_picker = _resolveComponent("v-date-picker")
  const _component_ToDoPhaseAddMemberIndividual = _resolveComponent("ToDoPhaseAddMemberIndividual")
  const _component_CheckAvaibilityByUser = _resolveComponent("CheckAvaibilityByUser")
  const _component_SuccessfulModalCustom = _resolveComponent("SuccessfulModalCustom")
  const _component_AppDeleteConfirmationModal = _resolveComponent("AppDeleteConfirmationModal")

  return (_openBlock(), _createBlock("div", null, [
    (_ctx.state.ui.isLoading.getPhaseDetails)
      ? (_openBlock(), _createBlock("div", _hoisted_1, [
          _hoisted_2
        ]))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_3, [
      _createVNode("h1", _hoisted_4, _toDisplayString(_ctx.$t('edit_task')), 1),
      _createVNode("div", _hoisted_5, [
        _createVNode("nav", _hoisted_6, [
          _createVNode("ol", _hoisted_7, [
            _createVNode("li", _hoisted_8, [
              _createVNode("a", _hoisted_9, [
                _hoisted_10,
                _createTextVNode(" " + _toDisplayString(_ctx.$t('home')), 1)
              ])
            ]),
            _createVNode("li", _hoisted_11, [
              _createVNode("a", _hoisted_12, _toDisplayString(_ctx.$t('edit_task')), 1)
            ]),
            _createVNode("li", _hoisted_13, _toDisplayString(_ctx.state.data.editTask.name), 1)
          ])
        ])
      ]),
      _createVNode("div", _hoisted_14, [
        _createVNode("div", _hoisted_15, [
          _createVNode("a", {
            href: "javascript:void(0)",
            class: "btn default-btn outline d-inline-block",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.viewSelectedPhaseDetails && _ctx.viewSelectedPhaseDetails(...args)))
          }, [
            _hoisted_16,
            _createTextVNode(" " + _toDisplayString(_ctx.$t('back')), 1)
          ])
        ])
      ])
    ]),
    _createVNode("div", _hoisted_17, [
      _createVNode(_component_ErrorList, {
        errors: _ctx.state.ui.error.errorList.updateTasks,
        hasError: _ctx.state.ui.error.hasError
      }, null, 8, ["errors", "hasError"]),
      _createVNode("div", _hoisted_18, [
        _createVNode("div", _hoisted_19, [
          _createVNode("div", _hoisted_20, [
            _createVNode("div", _hoisted_21, [
              _createVNode("h6", null, [
                _createVNode("strong", null, _toDisplayString(_ctx.$t('phase_name')) + ":", 1),
                _createTextVNode(" " + _toDisplayString(_ctx.state.data.phaseDetail.name), 1)
              ]),
              _createVNode("div", _hoisted_22, [
                _createVNode("div", _hoisted_23, [
                  _createVNode("div", _hoisted_24, [
                    _hoisted_25,
                    _createVNode("div", _hoisted_26, [
                      _createVNode("p", null, [
                        _createVNode("strong", null, _toDisplayString(_ctx.$t('budget')), 1)
                      ]),
                      _createVNode("p", null, "$ " + _toDisplayString(_ctx.state.data.phaseDetail.budget), 1)
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_27, [
                  _createVNode("div", _hoisted_28, [
                    _hoisted_29,
                    _createVNode("div", _hoisted_30, [
                      _createVNode("p", null, [
                        _createVNode("strong", null, _toDisplayString(_ctx.$t('phase_date')), 1)
                      ]),
                      _createVNode("p", null, [
                        _createVNode("span", _hoisted_31, _toDisplayString(_ctx.state.data.phaseDetail.startDate), 1),
                        _hoisted_32,
                        _createVNode("span", _hoisted_33, _toDisplayString(_ctx.state.data.phaseDetail.endDate), 1)
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _createVNode("div", _hoisted_34, [
              _createVNode("div", _hoisted_35, [
                _createVNode("div", _hoisted_36, [
                  _createVNode("div", _hoisted_37, [
                    _createVNode("label", _hoisted_38, _toDisplayString(_ctx.$t('name_of_task')), 1),
                    _withDirectives(_createVNode("input", {
                      type: "text",
                      class: "form-control",
                      id: "Name",
                      "aria-describedby": "Name",
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.state.data.editTask.name = $event)),
                      disabled: true
                    }, null, 512), [
                      [_vModelText, _ctx.state.data.editTask.name]
                    ])
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_39, [
                _createVNode("div", _hoisted_40, [
                  _createVNode("div", _hoisted_41, [
                    _createVNode("label", _hoisted_42, _toDisplayString(_ctx.$t('task_description')), 1),
                    _withDirectives(_createVNode("input", {
                      type: "text",
                      class: "form-control",
                      id: "Desc",
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.state.data.editTask.description = $event)),
                      disabled: true
                    }, null, 512), [
                      [_vModelText, _ctx.state.data.editTask.description]
                    ])
                  ])
                ])
              ])
            ]),
            _createVNode("div", _hoisted_43, [
              _createVNode("div", _hoisted_44, [
                _createVNode("div", _hoisted_45, [
                  _createVNode("div", _hoisted_46, [
                    _createVNode("label", _hoisted_47, _toDisplayString(_ctx.$t('task_priority')), 1),
                    _withDirectives(_createVNode("select", {
                      class: "form-control",
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.state.data.editTask.priority_id = $event)),
                      disabled: true
                    }, [
                      _createVNode("option", _hoisted_48, _toDisplayString(_ctx.$t('high')), 1),
                      _createVNode("option", _hoisted_49, _toDisplayString(_ctx.$t('medium')), 1),
                      _createVNode("option", _hoisted_50, _toDisplayString(_ctx.$t('low')), 1)
                    ], 512), [
                      [_vModelSelect, _ctx.state.data.editTask.priority_id]
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_51, [
                  _createVNode("div", _hoisted_52, [
                    _createVNode("label", _hoisted_53, _toDisplayString(_ctx.$t('task_estimated_budget')), 1),
                    _withDirectives(_createVNode("input", {
                      type: "text",
                      class: "form-control",
                      inputmode: "decimal",
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.state.data.editTask.budget = $event)),
                      disabled: true
                    }, null, 512), [
                      [_vModelText, _ctx.state.data.editTask.budget]
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_54, [
                  _createVNode("div", _hoisted_55, [
                    _createVNode("label", _hoisted_56, _toDisplayString(_ctx.$t('task_start_date')), 1),
                    _createVNode(_component_v_date_picker, {
                      modelValue: _ctx.state.data.updateStartDate,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.state.data.updateStartDate = $event)),
                      "min-date": _ctx.state.data.minDate,
                      "max-date": _ctx.state.data.maxDate
                    }, {
                      default: _withCtx(({ inputValue, inputEvents }) => [
                        _createVNode("input", _mergeProps({
                          class: "form-control",
                          value: inputValue
                        }, _toHandlers(inputEvents)), null, 16, ["value"])
                      ]),
                      _: 1
                    }, 8, ["modelValue", "min-date", "max-date"])
                  ])
                ]),
                _createVNode("div", _hoisted_57, [
                  _createVNode("div", _hoisted_58, [
                    _createVNode("label", _hoisted_59, _toDisplayString(_ctx.$t('task_end_date')), 1),
                    _createVNode(_component_v_date_picker, {
                      modelValue: _ctx.state.data.updateEndDate,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.state.data.updateEndDate = $event)),
                      "min-date": _ctx.state.data.minDate,
                      "max-date": _ctx.state.data.maxDate
                    }, {
                      default: _withCtx(({ inputValue, inputEvents }) => [
                        _createVNode("input", _mergeProps({
                          class: "form-control",
                          value: inputValue
                        }, _toHandlers(inputEvents)), null, 16, ["value"])
                      ]),
                      _: 1
                    }, 8, ["modelValue", "min-date", "max-date"])
                  ])
                ]),
                (_ctx.changedDetectedInDate)
                  ? (_openBlock(), _createBlock("div", _hoisted_60, [
                      _createVNode("div", _hoisted_61, [
                        _createVNode("label", _hoisted_62, _toDisplayString(_ctx.$t('reason')), 1),
                        _withDirectives(_createVNode("textarea", {
                          class: "form-control",
                          inputmode: "decimal",
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.state.data.reason = $event))
                        }, null, 512), [
                          [_vModelText, _ctx.state.data.reason]
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            (
              _ctx.state.data.invite.selectedMembers &&
              _ctx.state.data.invite.selectedMembers.length
            )
              ? (_openBlock(), _createBlock(_component_ToDoPhaseAddMemberIndividual, {
                  key: 0,
                  isEditMode: true,
                  permissions: _ctx.state.data.editAllData.permissions,
                  amountDepends: _ctx.state.data.editAllData.amount_depends,
                  roles: _ctx.state.data.editAllData.roles,
                  amountTypes: _ctx.state.data.editAllData.amount_types,
                  isShowDeleteMember: false,
                  isShowDeleteSlot: true,
                  onActiveTimeSlotForDelete: _ctx.activeTimeSlotForDelete,
                  onSelectedMemberIndex: _ctx.selectedMemberIndex,
                  onDeleteAmountType: _ctx.deleteAmountType,
                  onDeleteRole: _ctx.deleteRole,
                  onAddNewRole: _ctx.addNewRole,
                  onAddNewAmountType: _ctx.addNewAmountType,
                  onSelectedRoleForMember: _ctx.selectedRoleForMember,
                  onSelectedAmountTypeForMember: _ctx.selectedAmountTypeForMember,
                  members: _ctx.state.data.invite.selectedMembers,
                  onSelectedMember: _ctx.selectedMember,
                  onCheckWithRow: _ctx.checkWithRow,
                  onSelectedMemberForCheckAvaibility: _ctx.selectedMemberForCheckAvaibility
                
                }, null, 8, ["permissions", "amountDepends", "roles", "amountTypes", "onActiveTimeSlotForDelete", "onSelectedMemberIndex", "onDeleteAmountType", "onDeleteRole", "onAddNewRole", "onAddNewAmountType", "onSelectedRoleForMember", "onSelectedAmountTypeForMember", "members", "onSelectedMember", "onCheckWithRow", "onSelectedMemberForCheckAvaibility"]))
              : _createCommentVNode("", true),
            (
              _ctx.state.data.invite.invitedMembers &&
              _ctx.state.data.invite.invitedMembers.length
            )
              ? (_openBlock(), _createBlock("div", _hoisted_63, [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.invite
                .invitedMembers, (member, memberIndex) => {
                    return (_openBlock(), _createBlock("div", {
                      class: "col-md-4",
                      key: memberIndex
                    }, [
                      _createVNode("div", _hoisted_64, [
                        _createVNode("div", _hoisted_65, [
                          _createVNode("p", null, [
                            _createVNode("strong", null, _toDisplayString(member.email) + ":", 1),
                            _hoisted_66
                          ])
                        ])
                      ])
                    ]))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            (
              _ctx.changedDetectedInDate && _ctx.state.data.editAllData.notify_users
            )
              ? (_openBlock(), _createBlock("label", _hoisted_67, _toDisplayString(_ctx.$t('send_notification_to')), 1))
              : _createCommentVNode("", true),
            (_ctx.changedDetectedInDate)
              ? (_openBlock(), _createBlock("br", _hoisted_68))
              : _createCommentVNode("", true),
            (
              _ctx.changedDetectedInDate && _ctx.state.data.editAllData.notify_users
            )
              ? (_openBlock(), _createBlock("div", _hoisted_69, [
                  _createVNode("div", _hoisted_70, [
                    _createVNode("div", _hoisted_71, [
                      _createVNode("label", _hoisted_72, _toDisplayString(_ctx.$t('add_existing_member')), 1),
                      _withDirectives(_createVNode("select", {
                        disabled: _ctx.state.data.editAllData.notify_users &&
                    _ctx.state.data.editAllData.notify_users.length === 0
                    ,
                        class: "form-control",
                        id: "existingMember",
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.state.data.invite.notificationUsers = $event)),
                        onChange: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.changeNotificationMember && _ctx.changeNotificationMember(...args)))
                      }, [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.editAllData
                      .notify_users, (item, itemIndex) => {
                          return (_openBlock(), _createBlock("option", {
                            value: item.email,
                            key: itemIndex
                          }, _toDisplayString(item.full_name) + " (" + _toDisplayString(item.email) + ") ", 9, ["value"]))
                        }), 128))
                      ], 40, ["disabled"]), [
                        [_vModelSelect, _ctx.state.data.invite.notificationUsers]
                      ])
                    ]),
                    (
                  _ctx.state.data.invite.individualNotificationUsers &&
                  _ctx.state.data.invite.individualNotificationUsers.length
                )
                      ? (_openBlock(), _createBlock("div", _hoisted_73, [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.data.invite
                    .individualNotificationUsers, (email, emailIndex) => {
                            return (_openBlock(), _createBlock("div", {
                              class: "col-md-4",
                              key: emailIndex
                            }, [
                              _createVNode("div", _hoisted_74, [
                                _createVNode("a", {
                                  class: "remove-btnn",
                                  href: "javascript:void(0)",
                                  onClick: ($event: any) => (_ctx.deleteNotificationMember(email))
                                }, [
                                  _hoisted_75
                                ], 8, ["onClick"]),
                                _createVNode("div", _hoisted_76, [
                                  _createVNode("p", null, [
                                    _createVNode("small", null, _toDisplayString(email), 1)
                                  ])
                                ])
                              ])
                            ]))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]))
              : _createCommentVNode("", true),
            (
              _ctx.state.data.invite.selectedMembers &&
              _ctx.state.data.invite.selectedMembers.length
            )
              ? (_openBlock(), _createBlock("div", _hoisted_77, [
                  _createVNode("button", {
                    type: "submit",
                    class: "btn default-btn",
                    onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.updateTask && _ctx.updateTask(...args))),
                    disabled: _ctx.state.ui.isPostLoading.addMembersInPhases
                  }, _toDisplayString(_ctx.state.ui.isPostLoading.addMembersInPhases
                    ? _ctx.$t('loading1')
                    : _ctx.$t('update')), 9, ["disabled"])
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ]),
    (_ctx.state.data.showAvailibilityModal)
      ? (_openBlock(), _createBlock(_component_CheckAvaibilityByUser, {
          key: 1,
          startDate: _ctx.state.data.updateStartDate,
          endDate: _ctx.state.data.updateEndDate,
          phaseDetails: _ctx.state.data.editAllData,
          activeTab: _ctx.state.data.activeTab,
          isActive: _ctx.state.data.showAvailibilityModal,
          selectedEmail: _ctx.state.data.selectedEmail,
          userDetails: _ctx.state.data.selectedUser,
          onCreatedEvent: _ctx.createdEvent,
          onDeletedEvent: _ctx.deletedEvent,
          onHideAvaibilityModal: _ctx.hideAvaibilityModal,
          activePhaseId: _ctx.state.data.editTask.uuid
        }, null, 8, ["startDate", "endDate", "phaseDetails", "activeTab", "isActive", "selectedEmail", "userDetails", "onCreatedEvent", "onDeletedEvent", "onHideAvaibilityModal", "activePhaseId"]))
      : _createCommentVNode("", true),
    (_ctx.state.data.showSuccesCustomModal)
      ? (_openBlock(), _createBlock(_component_SuccessfulModalCustom, {
          key: 2,
          onClose: _ctx.closeSuccessCustomModal,
          showModal: _ctx.state.data.showSuccesCustomModal,
          titleMessage: _ctx.state.data.successFulMessage
        }, null, 8, ["onClose", "showModal", "titleMessage"]))
      : _createCommentVNode("", true),
    (_ctx.state.data.showDeleteConfirmationModal)
      ? (_openBlock(), _createBlock(_component_AppDeleteConfirmationModal, {
          key: 3,
          showConfirmationModal: _ctx.state.data.showDeleteConfirmationModal,
          onButtonTrigger: _ctx.removeSelectedTimeSlot,
          onHideConfirmation: _ctx.hideConfirmation,
          message: _ctx.state.data.deleteTimeSlotModalMessage
        }, null, 8, ["showConfirmationModal", "onButtonTrigger", "onHideConfirmation", "message"]))
      : _createCommentVNode("", true)
  ]))
}